import React, { useState, useEffect, useRef } from 'react'
import './newprofile.sass'
import { DarkModeContext } from '../../global/Theme'
import { useContext } from 'react';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { ConnectionCard, ImageCard, ProfileCard, ProfileTab, StaredUserCard } from '../../components/profile';
import { getBookmarkedPosts, getUserImagePosts, getUserVideoPosts } from '../../api/feed';
import { EmptyScreen } from '../../components/common/EmptyScreen';
import { getStarredUsers } from '../../api/social';
import LovrFire from "../../lovrfire"

export default function NewProfile() {
    const { isDark } = useContext(DarkModeContext);
    const history = useHistory();
    const userDataStore = useSelector(state => state.userState)
    const [cIndex, setCIndex] = useState(0);
    const [starredUserList, setStarredUserList] = useState([]);
    const profileTab = useRef();
    const profileWrapper = useRef();
    const rightCol = useRef()
    const [width, setWidth] = useState(document.body.clientWidth);
    var header = profileTab;

    const id = useSelector(store => store.userState.id)
    const reduxImagePosts = useSelector(store => store.imagePosts)
    const reduxVideoPosts = useSelector(store => store.videoPosts)
    const reduxBMPosts = useSelector(store => store.bmPosts);
    const dispatch = useDispatch();

    useEffect(() => {
        profileWrapper.current.addEventListener('scroll', () => {
            if (width <= 840) {

                if (((profileWrapper.current.scrollTop + 80) >= header.current.offsetTop) && profileWrapper.current.scrollTop > 240) {
                    header.current.classList.add("sticky");
                    rightCol.current.classList.add('right-column-alt')
                    rightCol.current.classList.remove('right-column')
                } else if ((profileWrapper.current.scrollTop - 200) <= header.current.offsetTop) {
                    header.current.classList.remove("sticky");
                    rightCol.current.classList.remove('right-column-alt')
                    rightCol.current.classList.add('right-column')
                }
            }
        })
    }, [])

    let temp = [];
    let videoTemp = [];
    let bookmarkedTemp = []
    useEffect(() => {
        getUserImagePosts(id, (imagePostObserver) => {

            imagePostObserver.docs.forEach(post => {
                temp.push(post.data())
                const fTemp = temp.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)
                const sortedTemp = fTemp.sort((x, y) => y.time - x.time)
                dispatch({
                    type: 'ADD_IMAGE_POST',
                    payload: sortedTemp
                })
            });

        });

        getUserVideoPosts(id, (videoPostObserver) => {
            videoPostObserver.docs.forEach(post => {
                videoTemp.push(post.data());
                const fTemp = videoTemp.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)
                const sortedTemp = fTemp.sort((x, y) => y.time - x.time)
                dispatch({
                    type: 'ADD_VIDEO_POST',
                    payload: sortedTemp
                })
            })
        });

        getBookmarkedPosts(id, (bookmarkedObserver) => {
            bookmarkedObserver.docs.forEach(post => {
                bookmarkedTemp.push(post.data());
                const fTemp = bookmarkedTemp.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)
                const sortedTemp = fTemp.sort((x, y) => y.time - x.time)
                dispatch({
                    type: 'ADD_BM_POST',
                    payload: sortedTemp
                })
            })
        });

        if (videoTemp.length == 0) {
            dispatch({
                type: 'EMPTY_VIDEO_POST'
            })
        }
        if (temp.length == 0) {
            dispatch({
                type: 'EMPTY_IMAGE_POST'
            })
        }
        if (bookmarkedTemp.length == 0) {
            dispatch({
                type: 'EMPTY_BM_POST'
            })
        }
    }, [id])

    const updateIndex = (e) => {
        setCIndex(e)
    }

    const fetchStarredUsers = async () => {
        let temp = []
        getStarredUsers(id, async observer => {
            temp = [];
            for (var i = 0; i < observer.docs.length; i++) {
                const userData = await LovrFire.firestore().collection('users').doc(observer.docs[i].data().uid).get()
                temp.push(userData.data())
            }
            setStarredUserList(temp);
        });

    }

    useEffect(() => {
        fetchStarredUsers()
    }, [id])

    const firstUpload = () => {
        history.push({
            pathname: '/new-post'
        })
    }

    const explore = () => {
        history.push({
            pathname: '/search'
        })
    }

    const updateView = (v) => {
        if (v <= 586) {
            document.getElementById('mainWrapper').classList.remove('padding')
            document.getElementById('mainWrapper').classList.add('zero-p')
            document.getElementById('mobileNav').style.display = "none"

        } else {
            document.getElementById('mainWrapper').classList.add('padding')
            document.getElementById('mainWrapper').classList.remove('zero-p')
            document.getElementById('mobileNav').style.display = "none"
        }
    }

    useEffect(() => {
        if (document.body.clientWidth < 580) {
            document.getElementById('mobileNav').style.display = "none"
        }
        window.addEventListener('resize', v => {
            updateView(v.target.innerWidth)
        })
       
    }, [])


    return (
        <div ref={profileWrapper} className="profile-wrapper">
            <div className="left-column"  >
                <div className="left-column-header">
                    <div className={`${isDark ? 'profile-name-card-dark' : 'profile-name-card-light'}`}>
                        <img style={{ zIndex: '2' }} onClick={() => { history.push('/settings') }} src={require('../../assets/icons/cog.svg')} alt="settings" />
                        <p>{userDataStore.username}</p>
                    </div>
                </div>
                <div className="left-column-content">
                    <ProfileCard />
                </div>
            </div>
            <div className="right-column" ref={rightCol}>
                <div className="right-column-header" id="Header" ref={profileTab}>
                    <ProfileTab handleOnClick={updateIndex} activeIndex={cIndex} />
                </div>
                <div className="right-column-content">
                    {
                        cIndex == 0 ?
                            <div id="postPics">
                                {
                                    (reduxImagePosts && reduxImagePosts.length === 0) ?
                                        <EmptyScreen logo='plus_a' heading='Your LOVR Profile' description='When you share photos, they’ll appear on your profile.' handleClick={firstUpload} btntext='Share your first photo' /> :
                                        reduxImagePosts && reduxImagePosts.map((v) => <ImageCard img={v.media} thumb={v.thumbnail} userId={v.user} postId={v.id} type={1} />)
                                }
                            </div> :
                            <div> </div>
                    }
                    {
                        cIndex == 1 ?
                            <div id="postVideos">
                                {
                                    (reduxVideoPosts && reduxVideoPosts.length === 0) ?
                                        <EmptyScreen logo='camcorder' heading='Your LOVR Profile' description='When you share videos, they’ll appear on your profile.' handleClick={firstUpload} btntext='Share your first video' /> :
                                        reduxVideoPosts && reduxVideoPosts.map((v) => <ImageCard img={v.media} userId={v.user} postId={v.id} type={2} />)
                                }
                            </div> :
                            <div> </div>
                    }

                    {
                        cIndex == 2 ?
                            <div id="postBM">
                                {
                                    (reduxBMPosts && reduxBMPosts.length === 0) ?
                                        <EmptyScreen logo='bookmark_a' heading='Bookmarks' description='Start saving posts you love the most, to watch them later.' handleClick={explore} btntext='Bookmark your first post' /> :
                                        reduxBMPosts && reduxBMPosts.map((v) => <ImageCard img={v.media} thumb={v.thumbnail} userId={v.user} postId={v.id} type={v.type} />)
                                }
                            </div> :
                            <div> </div>
                    }

                    {
                        cIndex == 3 ?
                            <div id="postStars">
                                {
                                    (starredUserList && starredUserList.length === 0) ?
                                        <EmptyScreen logo='star_a' heading='Favorite LOVRs' description='Make your personal list with your favorite LOVRs to access them more faster.' handleClick={explore} btntext='Explore LOVRs' /> :
                                        starredUserList && starredUserList.length > 0 && starredUserList.map(user => <StaredUserCard username={user.username} name={user.name} image={user.image} id={user.id} />)
                                }

                            </div> :
                            <div> </div>
                    }

                    {
                        cIndex == 4 ?
                            <div id="postConnections">
                                <div className="profile-connection-mobile-row">
                                    <ConnectionCard type='website' isActive={(userDataStore.socialMedia != null && userDataStore.socialMedia.website.length > 0) ? true : false} img='website.png' page={(userDataStore.socialMedia !== null && userDataStore.socialMedia.website.length > 0) ? userDataStore.socialMedia.website : "#"} />
                                    <ConnectionCard type='instagram' isActive={(userDataStore.socialMedia != null && userDataStore.socialMedia.instagram.length > 0) ? true : false} img='instagram.png' page={(userDataStore.socialMedia !== null && userDataStore.socialMedia.instagram.length > 0) ? userDataStore.socialMedia.instagram : "#"} />
                                </div>
                                <div className="profile-connection-mobile-row">
                                    <ConnectionCard type='spotify' isActive={(userDataStore.socialMedia != null && userDataStore.socialMedia.spotify.length > 0) ? true : false} img='spotify.png' page={(userDataStore.socialMedia !== null && userDataStore.socialMedia.spotify.length > 0) ? userDataStore.socialMedia.spotify : "#"} />
                                    <ConnectionCard type='tiktok' isActive={(userDataStore.socialMedia != null && userDataStore.socialMedia.tiktok.length > 0) ? true : false} img='tiktok.png' page={(userDataStore.socialMedia !== null && userDataStore.socialMedia.tiktok.length > 0) ? userDataStore.socialMedia.tiktok : "#"} />
                                </div>
                                <div className="profile-connection-mobile-row">
                                    <ConnectionCard type='pornhub' isActive={(userDataStore.socialMedia != null && userDataStore.socialMedia.pornhub.length > 0) ? true : false} img='pornhub.png' page={(userDataStore.socialMedia !== null && userDataStore.socialMedia.pornhub.length > 0) ? userDataStore.socialMedia.pornhub : "#"} />
                                    <ConnectionCard type='snapchat' isActive={(userDataStore.socialMedia != null && userDataStore.socialMedia.snapchat.length > 0) ? true : false} img='snapchat.png' page={(userDataStore.socialMedia !== null && userDataStore.socialMedia.snapchat.length > 0) ? userDataStore.socialMedia.snapchat : "#"} />
                                </div>
                                <div className="profile-connection-mobile-row">
                                    <ConnectionCard type='twitter' isActive={(userDataStore.socialMedia != null && userDataStore.socialMedia.twitter.length > 0) ? true : false} img='twitter.png' page={(userDataStore.socialMedia !== null && userDataStore.socialMedia.twitter.length > 0) ? userDataStore.socialMedia.twitter : "#"} />
                                    <ConnectionCard type='twitch' isActive={(userDataStore.socialMedia != null && userDataStore.socialMedia.twitch.length > 0) ? true : false} img='twitch.png' page={(userDataStore.socialMedia !== null && userDataStore.socialMedia.twitch.length > 0) ? userDataStore.socialMedia.twitch : "#"} />
                                </div>
                            </div> :
                            <div> </div>
                    }


                </div>

            </div>
        </div>
    )
}
